import { OutlinedInput } from '@mui/material';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';

import styles from './styles.module.scss';

export const InputStyled = (props: OutlinedInputProps) => {
  return (
    <OutlinedInput
      {...props}
      color="secondary"
      classes={{
        root: styles.inputWrapper,
        input: styles.input,
        notchedOutline: styles.fieldset,
        focused: styles.fieldset,
        error: styles.error,
      }}
    />
  );
};
